import { render, staticRenderFns } from "./TagSetPicker.vue?vue&type=template&id=3ae2e8c7&"
import script from "./TagSetPicker.vue?vue&type=script&lang=ts&"
export * from "./TagSetPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports